export const JCO_ORGANIZATION_ID = "aa9be45c-5d2c-4dbc-b586-c82f1619d895";
export const KEPLERA_JCO_COURSE_ID = "98823c64-6538-4063-a2f9-62146b9e6395";
export const KEPLERA_COURSE_ID = "3158f4f5-6100-40dd-96c0-6b4d18af48d6";
export const BORG_COURSE_ID = "3757a0e0-01bc-4ccc-a3ed-e37e8118e416";
export const IS_KEPLERA_VERSION = process.env.REACT_APP_PRODUCT_NAME === "keplera";

export const getCourseId = (organizationId? : string) => {
  // if the version is Keplera and the organization is JCO, use the JCO-specific Keplera course
  if(IS_KEPLERA_VERSION && organizationId === JCO_ORGANIZATION_ID)
    return KEPLERA_JCO_COURSE_ID;    
  // otherwise, use vanilla Keplera or BORG courses
  return IS_KEPLERA_VERSION ? KEPLERA_COURSE_ID : BORG_COURSE_ID;;
}